<div class="notFoundComp">
  <div class="arrow-img" *ngIf="showErrorCode">
    <img width="60px" height="auto" src="./assets/icons/arrow.svg" />
  </div>

  <div class="main-container">
    <div class="text-404" *ngIf="showErrorCode">
      <span>{{ errorCode }}</span>
    </div>
    <div class="child-container">
      <h3 class="page-not-found">
        {{ errorTitle }}
      </h3>
      <div class="normalText">{{ errorMessage }}</div>

      <div class="back-to-dashboard" [class.center-button]="!showErrorCode">
        <div>
          <button type="button" [routerLink]="buttonRoute" class="next-btn modelBtn">
            <i class="bi bi-arrow-left back-icon"></i>
            {{ buttonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
